<template>
  <div class="side-wrap">
    <div class="title-wrap">
      <img class="icon-img" src="/static/iconHot.png" alt="" />
      <span class="title">热门标签</span>
    </div>
    <div class="hotLabel">
      <div
        v-for="(item, key) in hostList"
        :key="'item' + key"
        :title="item"
        :class="{ activeClass: activeIndex === key }"
      >
        <a-icon
          type="close-circle"
          v-if="activeIndex === key"
          class="icon"
          @click="detailClick('', key)"
        />
        <span v-if="item !== null" @click="detailClick(item, key)">{{
          item
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { hotTag } from '@/api/technicalR'

export default {
  data() {
    return {
      hostList: [],
      activeIndex: ''
    }
  },
  async created() {
    const { data } = await hotTag()
    this.hostList = data
  },
  methods: {
    async detailClick(val, key) {
      if (val !== '') {
        this.activeIndex = key
        this.$emit('detailClick', val)
      } else {
        this.activeIndex = ''
        this.$emit('detailClick', '')
      }
    }
  }
}
</script>
